import { NextImageProps } from '@/decodo/components/atoms/Image';
import ImageStrapi, {
  ImageStrapiProps,
} from '@/decodo/components/atoms/Image/ImageStrapi';
import LinkButton from '@/decodo/components/atoms/LinkButton';
import { Text } from '@/decodo/components/atoms/Text';
import { cn } from '@/lib/utils';

export type FeatureListStrapiProps = {
  features: {
    id: number;
    name: string;
    icon?: ImageStrapiProps;
    url?: string;
  }[];
  icon?: ImageStrapiProps;
  classNames?: {
    itemRoot?: string;
    item?: string;
    icon?: NextImageProps['classNames'];
  };
};

export function FeatureListStrapi({
  features,
  icon,
  classNames,
}: FeatureListStrapiProps) {
  return (
    <>
      {features?.map((feature, index) => (
        <div
          key={index}
          className={cn('flex items-center gap-2', classNames?.itemRoot)}
          data-tracker-component='feature-item'
        >
          {(feature?.icon || icon) && (
            <ImageStrapi
              inner={{
                classNames: {
                  ...classNames?.icon,
                  image: cn('w-6', classNames?.icon?.image),
                },
              }}
              block={feature?.icon || (icon as ImageStrapiProps)}
            />
          )}
          {feature.url ? (
            <LinkButton
              href={feature.url}
              variant='text'
              color='secondary'
              slim
              classNames={{ root: classNames?.item }}
            >
              {feature.name}
            </LinkButton>
          ) : (
            <Text classNames={{ wrapper: classNames?.item }}>
              {feature.name}
            </Text>
          )}
        </div>
      ))}
    </>
  );
}
